export default IconLocationX => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-location-x" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M13.5 21l-.224 -.448l-3.276 -6.552l-7 -3.5a.55 .55 0 0 1 0 -1l18 -6.5l-3.622 10.03" />
  <path d="M22 22l-5 -5" />
  <path d="M17 22l5 -5" />
</svg>`;